export const Config = {
  BACKEND_URL: "https://api.incluway.de/api",
  translatorConfig: {
    key: "6mEKfTLv7H7SP6h9uKVhPl5cwJ8gPJG3qKs0VIouEaCn3ntwme37JQQJ99BDAC1i4TkXJ3w3AAAbACOGK8hE",
    region: "centralus",
    endpoint:
      "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0",
  },
};
